{
  "about.blocks": "Moderearre servers",
  "about.contact": "Kontakt:",
  "about.default_locale": "Standert",
  "about.disclaimer": "Mastodon is frije, iepenboarnesoftware en in hannelsmerk fan Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Reden net beskikber",
  "about.domain_blocks.preamble": "Yn it algemien kinne jo mei Mastodon berjochten ûntfange fan, en ynteraksje hawwe mei brûkers fan elke server yn de fediverse. Dit binne de útsûnderingen dy’t op dizze spesifike server jilde.",
  "about.domain_blocks.silenced.explanation": "Yn it algemien sjogge jo gjin berjochten en accounts fan dizze server, útsein as jo berjochten eksplisyt opsikje of derfoar kieze om in account fan dizze server te folgjen.",
  "about.domain_blocks.silenced.title": "Beheind",
  "about.domain_blocks.suspended.explanation": "Der wurde gjin gegevens fan dizze server ferwurke, bewarre of útwiksele, wat ynteraksje of kommunikaasje mei brûkers fan dizze server ûnmooglik makket.",
  "about.domain_blocks.suspended.title": "Utsteld",
  "about.language_label": "Taal",
  "about.not_available": "Dizze ynformaasje is troch dizze server net iepenbier makke.",
  "about.powered_by": "Desintralisearre sosjale media, mooglik makke troch {mastodon}",
  "about.rules": "Serverrigels",
  "account.account_note_header": "Persoanlike opmerking",
  "account.add_or_remove_from_list": "Tafoegje oan of fuortsmite út listen",
  "account.badges.bot": "Automatisearre",
  "account.badges.group": "Groep",
  "account.block": "@{name} blokkearje",
  "account.block_domain": "Domein {domain} blokkearje",
  "account.block_short": "Blokkearje",
  "account.blocked": "Blokkearre",
  "account.cancel_follow_request": "Folchfersyk annulearje",
  "account.copy": "Keppeling nei profyl kopiearje",
  "account.direct": "Privee fermelde @{name}",
  "account.disable_notifications": "Jou gjin melding mear wannear @{name} in berjocht pleatst",
  "account.edit_profile": "Profyl bewurkje",
  "account.enable_notifications": "Jou in melding mear wannear @{name} in berjocht pleatst",
  "account.endorse": "Op profyl werjaan",
  "account.familiar_followers_many": "Folge troch {name1}, {name2} en {othersCount, plural, one {ien oar bekend account} other {# oare bekende accounts}}",
  "account.familiar_followers_one": "Folge troch {name1}",
  "account.familiar_followers_two": "Folge troch {name1} en {name2}",
  "account.featured": "Foarsteld",
  "account.featured.accounts": "Profilen",
  "account.follow": "Folgje",
  "account.follow_back": "Weromfolgje",
  "account.followers": "Folgers",
  "account.followers.empty": "Noch net ien folget dizze brûker.",
  "account.followers_counter": "{count, plural, one {{counter} folger} other {{counter} folgers}}",
  "account.followers_you_know_counter": "{counter} dy’t jo kinne",
  "account.following": "Folgjend",
  "account.following_counter": "{count, plural, one {{counter} folgjend} other {{counter} folgjend}}",
  "account.follows.empty": "Dizze brûker folget noch net ien.",
  "account.follows_you": "Folget jo",
  "account.go_to_profile": "Gean nei profyl",
  "account.hide_reblogs": "Boosts fan @{name} ferstopje",
  "account.in_memoriam": "Yn memoriam.",
  "account.joined_short": "Registrearre op",
  "account.languages": "Toande talen wizigje",
  "account.link_verified_on": "Eigendom fan dizze keppeling is kontrolearre op {date}",
  "account.locked_info": "De privacysteat fan dizze account is op beskoattele set. De eigener bepaalt hânmjittich wa’t dyjinge folgje kin.",
  "account.media": "Media",
  "account.mention": "@{name} fermelde",
  "account.moved_to": "{name} is ferhuze nei:",
  "account.mute": "@{name} negearje",
  "account.mute_notifications_short": "Meldingen negearje",
  "account.mute_short": "Negearje",
  "account.muted": "Negearre",
  "account.mutual": "Jim folgje inoar",
  "account.no_bio": "Gjin omskriuwing opjûn.",
  "account.open_original_page": "Orizjinele side iepenje",
  "account.posts": "Berjochten",
  "account.remove_from_followers": "{name} as folger fuortsmite",
  "account.report": "@{name} rapportearje",
  "account.requested_follow": "{name} hat dy in folchfersyk stjoerd",
  "account.share": "Profyl fan @{name} diele",
  "account.show_reblogs": "Boosts fan @{name} toane",
  "account.statuses_counter": "{count, plural, one {{counter} berjocht} other {{counter} berjochten}}",
  "account.unblock": "@{name} deblokkearje",
  "account.unblock_domain": "Domein {domain} deblokkearje",
  "account.unblock_domain_short": "Deblokkearje",
  "account.unblock_short": "Deblokkearje",
  "account.unendorse": "Net op profyl werjaan",
  "account.unfollow": "Net mear folgje",
  "account.unmute": "@{name} net langer negearje",
  "account.unmute_notifications_short": "Meldingen net mear negearje",
  "account.unmute_short": "Net mear negearje",
  "account_note.placeholder": "Klik om notysje ta te foegjen",
  "admin.dashboard.daily_retention": "Brûkerretinsjegraad per dei nei oanmelding",
  "admin.dashboard.monthly_retention": "Brûkerretinsjegraad per moanne nei oanmelding",
  "admin.dashboard.retention.average": "Gemiddelde",
  "admin.dashboard.retention.cohort": "Registraasjemoanne",
  "admin.dashboard.retention.cohort_size": "Nije brûkers",
  "admin.impact_report.instance_accounts": "Oantal accounts dat troch dizze aksje fuortsmiten wurdt",
  "admin.impact_report.instance_followers": "Oantal folgers dy’t ús brûkers ferlieze soene",
  "admin.impact_report.instance_follows": "Oantal folgers dy’t harren brûkers ferlieze soene",
  "admin.impact_report.title": "Oersjoch fan de gefolgen",
  "alert.rate_limited.message": "Opnij probearje nei {retry_time, time, medium}.",
  "alert.rate_limited.title": "Dataferkear beheind",
  "alert.unexpected.message": "Der is in ûnferwachte flater bard.",
  "alert.unexpected.title": "Oepsy!",
  "alt_text_badge.title": "Alternative tekst",
  "alt_text_modal.add_alt_text": "Alt-tekst tafoegje",
  "alt_text_modal.add_text_from_image": "Tekst fan ôfbylding tafoegje",
  "alt_text_modal.cancel": "Annulearje",
  "alt_text_modal.change_thumbnail": "Miniatuerôfbylding wizigje",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Beskriuw dit foar dôven en hurdhearrige…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Beskriuw dit foar blinen en fisueel beheinde…",
  "alt_text_modal.done": "Klear",
  "announcement.announcement": "Oankundiging",
  "annual_report.summary.most_used_app.most_used_app": "meast brûkte app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "meast brûkte hashtag",
  "annual_report.summary.new_posts.new_posts": "nije berjochten",
  "annual_report.summary.percentile.text": "<topLabel>Hjirmei hearre jo ta de top</topLabel><percentage></percentage><bottomLabel> fan {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Wy sille Bernie neat fertelle.",
  "attachments_list.unprocessed": "(net ferwurke)",
  "audio.hide": "Audio ferstopje",
  "block_modal.remote_users_caveat": "Wy freegje de server {domain} om jo beslút te respektearjen. It neilibben hjirfan is echter net garandearre, omdat guon servers blokkaden oars ynterpretearje kinne. Iepenbiere berjochten binne mooglik noch hieltyd sichtber foar net-oanmelde brûkers.",
  "block_modal.show_less": "Minder toane",
  "block_modal.show_more": "Mear toane",
  "block_modal.they_will_know": "De persoan kin sjen dat dy blokkearre wurdt.",
  "block_modal.title": "Brûker blokkearje?",
  "boost_modal.combo": "Jo kinne op {combo} drukke om dit de folgjende kear oer te slaan",
  "boost_modal.reblog": "Berjocht booste?",
  "boost_modal.undo_reblog": "Berjocht net langer booste?",
  "bundle_column_error.copy_stacktrace": "Flaterrapport kopiearje",
  "bundle_column_error.error.body": "De opfrege side koe net werjûn wurde. It kin wêze troch in flater yn ús koade, of in probleem mei browserkompatibiliteit.",
  "bundle_column_error.error.title": "Oh nee!",
  "bundle_column_error.network.body": "Der is in flater bard by it laden fan dizze side. Dit kin komme troch in tydlik probleem mei jo ynternetferbining of dizze server.",
  "bundle_column_error.network.title": "Netwurkflater",
  "bundle_column_error.retry": "Opnij probearje",
  "bundle_column_error.return": "Tebek nei startside",
  "bundle_column_error.routing.body": "De opfrege side kin net fûn wurde. Binne jo wis dat de URL yn de adresbalke goed is?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Slute",
  "bundle_modal_error.message": "Der gie wat mis by it laden fan dit skerm.",
  "bundle_modal_error.retry": "Opnij probearje",
  "closed_registrations.other_server_instructions": "Omdat Mastodon desintralisearre is, kinne jo in account meitsje op in oare server en noch hieltyd ynteraksje hawwe mei dizze.",
  "closed_registrations_modal.description": "It oanmeitsjen fan in account op {domain} is op dit stuit net mooglik, mar hâld asjebleaft yn gedachten dat jo gjin account spesifyk op {domain} nedich hawwe om Mastodon te brûken.",
  "closed_registrations_modal.find_another_server": "Sykje in oare server",
  "closed_registrations_modal.preamble": "Mastodon is desintralisearre, dus nettsjinsteande wêr't jo jo account oanmeitsje, jo kinne elkenien op dizze server folgje en der ynteraksje mei hawwe. Jo kinne it sels sels hoste!",
  "closed_registrations_modal.title": "Oanmelde op Mastodon",
  "column.about": "Oer",
  "column.blocks": "Blokkearre brûkers",
  "column.bookmarks": "Blêdwizers",
  "column.community": "Lokale tiidline",
  "column.create_list": "List oanmeitsje",
  "column.direct": "Priveefermeldingen",
  "column.directory": "Profilen trochsykje",
  "column.domain_blocks": "Blokkearre domeinen",
  "column.edit_list": "List bewurkje",
  "column.favourites": "Favoriten",
  "column.firehose": "Live feeds",
  "column.follow_requests": "Folchfersiken",
  "column.home": "Startside",
  "column.list_members": "Listleden beheare",
  "column.lists": "Listen",
  "column.mutes": "Negearre brûkers",
  "column.notifications": "Meldingen",
  "column.pins": "Fêstsette berjochten",
  "column.public": "Globale tiidline",
  "column_back_button.label": "Tebek",
  "column_header.hide_settings": "Ynstellingen ferstopje",
  "column_header.moveLeft_settings": "Kolom nei links ferpleatse",
  "column_header.moveRight_settings": "Kolom nei rjochts ferpleatse",
  "column_header.pin": "Fêstsette",
  "column_header.show_settings": "Ynstellingen toane",
  "column_header.unpin": "Losmeitsje",
  "column_search.cancel": "Annulearje",
  "community.column_settings.local_only": "Allinnich lokaal",
  "community.column_settings.media_only": "Allinnich media",
  "community.column_settings.remote_only": "Allinnich oare servers",
  "compose.language.change": "Taal wizigje",
  "compose.language.search": "Talen sykje…",
  "compose.published.body": "Berjocht publisearre.",
  "compose.published.open": "Toane",
  "compose.saved.body": "Berjocht bewarre.",
  "compose_form.direct_message_warning_learn_more": "Mear ynfo",
  "compose_form.encryption_warning": "Berjochten op Mastodon wurde, krekt as op oare sosjale media, net ein-ta-ein fersifere. Diel dêrom gjin gefoelige ynformaasje fia Mastodon.",
  "compose_form.hashtag_warning": "Dit berjocht falt net ûnder in hashtag te besjen, omdat dizze net op iepenbier is. Allinnich iepenbiere berjochten kinne fia hashtags fûn wurde.",
  "compose_form.lock_disclaimer": "Jo account is net {locked}. Elkenien kin jo folgje en kin de berjochten sjen dy’t jo allinnich oan jo folgers rjochte hawwe.",
  "compose_form.lock_disclaimer.lock": "beskoattele",
  "compose_form.placeholder": "Wat wolle jo kwyt?",
  "compose_form.poll.duration": "Doer fan de enkête",
  "compose_form.poll.multiple": "Mearkar",
  "compose_form.poll.option_placeholder": "Opsje {number}",
  "compose_form.poll.single": "Inkelde kar",
  "compose_form.poll.switch_to_multiple": "Enkête wizigje om meardere karren ta te stean",
  "compose_form.poll.switch_to_single": "Enkête wizigje om in inkelde kar ta te stean",
  "compose_form.poll.type": "Styl",
  "compose_form.publish": "Toot",
  "compose_form.reply": "Reagearje",
  "compose_form.save_changes": "Bywurkje",
  "compose_form.spoiler.marked": "Ynhâldswarskôging fuortsmite",
  "compose_form.spoiler.unmarked": "Ynhâldswarskôging tafoegje",
  "compose_form.spoiler_placeholder": "Ynhâldswarskôging (opsjoneel)",
  "confirmation_modal.cancel": "Annulearje",
  "confirmations.block.confirm": "Blokkearje",
  "confirmations.delete.confirm": "Fuortsmite",
  "confirmations.delete.message": "Binne jo wis dat jo dit berjocht fuortsmite wolle?",
  "confirmations.delete.title": "Berjocht fuortsmite?",
  "confirmations.delete_list.confirm": "Fuortsmite",
  "confirmations.delete_list.message": "Binne jo wis dat jo dizze list foar permanint fuortsmite wolle?",
  "confirmations.delete_list.title": "List fuortsmite?",
  "confirmations.discard_draft.confirm": "Negearje en trochgean",
  "confirmations.discard_draft.edit.cancel": "Bewurkjen trochsette",
  "confirmations.discard_draft.edit.message": "Trochsette sil wizigingen dy’t jo oan it aktuele berjocht makke hawwe negearje.",
  "confirmations.discard_draft.edit.title": "Wizigingen oan jo berjocht negearje?",
  "confirmations.discard_draft.post.cancel": "Konsept trochsette",
  "confirmations.discard_draft.post.message": "Trochsette sil it aktuele berjocht negearje.",
  "confirmations.discard_draft.post.title": "Jo konseptberjocht negearje?",
  "confirmations.discard_edit_media.confirm": "Fuortsmite",
  "confirmations.discard_edit_media.message": "Jo hawwe net-bewarre wizigingen yn de mediabeskriuwing of foarfertoaning, wolle jo dizze dochs fuortsmite?",
  "confirmations.follow_to_list.confirm": "Folgje en tafoegje oan de list",
  "confirmations.follow_to_list.message": "Jo moatte {name} folgje om se ta te foegjen oan in list.",
  "confirmations.follow_to_list.title": "Brûker folgje?",
  "confirmations.logout.confirm": "Ofmelde",
  "confirmations.logout.message": "Binne jo wis dat jo ôfmelde wolle?",
  "confirmations.logout.title": "Ofmelde?",
  "confirmations.missing_alt_text.confirm": "Alt-tekst tafoegje",
  "confirmations.missing_alt_text.message": "Jo berjocht befettet media sûnder alt-tekst. It tafoegjen fan beskriuwingen helpt jo om jo ynhâld tagonklik te meitsjen foar mear minsken.",
  "confirmations.missing_alt_text.secondary": "Dochs pleatse",
  "confirmations.missing_alt_text.title": "Alt-tekst tafoegje?",
  "confirmations.mute.confirm": "Negearje",
  "confirmations.redraft.confirm": "Fuortsmite en opnij opstelle",
  "confirmations.redraft.message": "Binne jo wis dat jo dit berjocht fuortsmite en opnij opstelle wolle? Favoriten en boosts geane dan ferlern en reaksjes op it oarspronklike berjocht reitsje jo kwyt.",
  "confirmations.redraft.title": "Berjocht fuortsmite en opnij opstelle?",
  "confirmations.remove_from_followers.confirm": "Folger fuortsmite",
  "confirmations.remove_from_followers.message": "{name} sil jo net mear folgje. Binne jo wis dat jo trochgean wolle?",
  "confirmations.remove_from_followers.title": "Folger fuortsmite?",
  "confirmations.unfollow.confirm": "Net mear folgje",
  "content_warning.hide": "Berjocht ferstopje",
  "content_warning.show": "Dochs toane",
  "content_warning.show_more": "Mear toane",
  "conversation.delete": "Petear fuortsmite",
  "conversation.mark_as_read": "As lêzen markearje",
  "conversation.open": "Petear toane",
  "conversation.with": "Mei {names}",
  "copy_icon_button.copied": "Nei klamboerd kopiearre",
  "copypaste.copied": "Kopiearre",
  "copypaste.copy_to_clipboard": "Nei klamboerd kopiearje",
  "directory.federated": "Fediverse (wat bekend is)",
  "directory.local": "Allinnich fan {domain}",
  "directory.new_arrivals": "Nije accounts",
  "directory.recently_active": "Resint aktyf",
  "disabled_account_banner.account_settings": "Accountynstellingen",
  "disabled_account_banner.text": "Jo account {disabledAccount} is op dit stuit útskeakele.",
  "dismissable_banner.community_timeline": "Dit binne de meast resinte iepenbiere berjochten fan accounts op {domain}.",
  "dismissable_banner.dismiss": "Slute",
  "dismissable_banner.public_timeline": "Dit binne de meast resinte iepenbiere berjochten fan accounts op de fediverse dy’t troch minsken op {domain} folge wurde.",
  "domain_block_modal.block": "Server blokkearje",
  "domain_block_modal.block_account_instead": "Yn stee hjirfan {name} blokkearje",
  "domain_block_modal.they_can_interact_with_old_posts": "Minsken op dizze server kinne ynteraksje hawwe mei jo âlde berjochten.",
  "domain_block_modal.they_cant_follow": "Net ien op dizze server kin jo folgje.",
  "domain_block_modal.they_wont_know": "Se krije net te witten dat se blokkearre wurde.",
  "domain_block_modal.title": "Domein blokkearje?",
  "domain_block_modal.you_will_lose_num_followers": "Jo ferlieze {followersCount, plural, one {{followersCountDisplay} folger} other {{followersCountDisplay} folgers}} en {followingCount, plural, one {{followingCountDisplay} persoan dy’t jo folgje} other {{followingCountDisplay} persoanen dy’t jo folgje}}.",
  "domain_block_modal.you_will_lose_relationships": "Jo ferlieze alle folgers en minsken dy’t jo folgje fan dizze server.",
  "domain_block_modal.you_wont_see_posts": "Jo sjogge gjin berjochten of meldingen mear fan brûkers op dizze server.",
  "domain_pill.activitypub_lets_connect": "It soarget derfoar dat jo net allinnich mar ferbine en kommunisearje kinne mei minsken op Mastodon, mar ek mei oare sosjale apps.",
  "domain_pill.activitypub_like_language": "ActivityPub is de taal dy’t Mastodon mei oare sosjale netwurken sprekt.",
  "domain_pill.server": "Server",
  "domain_pill.their_handle": "Harren fediverse-adres:",
  "domain_pill.their_server": "Harren digitale thús, wer’t al harren berjochten binne.",
  "domain_pill.their_username": "Harren unike identifikaasje-adres op harren server. It is mooglik dat der brûkers mei deselde brûkersnamme op ferskate servers te finen binne.",
  "domain_pill.username": "Brûkersnamme",
  "domain_pill.whats_in_a_handle": "Wat is in fediverse-adres?",
  "domain_pill.who_they_are": "Omdat jo oan in fediverse-adres sjen kinne hoe’t ien hjit en op hokker server dy sit, kinne jo mei minsken op it troch <button>ActivityPub oandreaune</button> sosjale web (fediverse) kommunisearje.",
  "domain_pill.who_you_are": "Omdat jo oan in fediverse-adres sjen kinne hoe’t jo hjitte en op hokker server jo sitte, kinne jo mei minsken op it troch <button>ActivityPub oandreaune</button> sosjale web (fediverse) kommunisearje.",
  "domain_pill.your_handle": "Jo fediverse-adres:",
  "domain_pill.your_server": "Jo digitale thús, wer't al jo berjochten stean. Is dizze server dochs net nei jo winsk? Dan kinne jo op elk momint nei in oare server ferhúzje en ek jo folgers oerbringe.",
  "domain_pill.your_username": "Jo unike identifikaasje-adres op dizze server. It is mooglik dat der brûkers mei deselde brûkersnamme op ferskate servers te finen binne.",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "embed.preview": "Sa komt it der út te sjen:",
  "emoji_button.activity": "Aktiviteiten",
  "emoji_button.clear": "Wiskje",
  "emoji_button.custom": "Oanpast",
  "emoji_button.flags": "Flaggen",
  "emoji_button.food": "Iten en drinken",
  "emoji_button.label": "Emoji tafoegje",
  "emoji_button.nature": "Natuer",
  "emoji_button.not_found": "Gjin oerienkommende emoji fûn",
  "emoji_button.objects": "Objekten",
  "emoji_button.people": "Minsken",
  "emoji_button.recent": "Faaks brûkt",
  "emoji_button.search": "Sykje…",
  "emoji_button.search_results": "Sykresultaten",
  "emoji_button.symbols": "Symboalen",
  "emoji_button.travel": "Reizgje en lokaasjes",
  "empty_column.account_hides_collections": "Dizze brûker hat derfoar keazen dizze ynformaasje net beskikber te meitsjen",
  "empty_column.account_suspended": "Account beskoattele",
  "empty_column.account_timeline": "Hjir binne gjin berjochten!",
  "empty_column.account_unavailable": "Profyl net beskikber",
  "empty_column.blocks": "Jo hawwe noch gjin brûkers blokkearre.",
  "empty_column.bookmarked_statuses": "Jo hawwe noch gjin berjochten oan jo blêdwizers tafoege. Wannear’t jo der ien oan jo blêdwizers tafoegje, falt dizze hjir te sjen.",
  "empty_column.community": "De lokale tiidline is noch leech. Pleats in iepenbier berjocht om de spits ôf te biten!",
  "empty_column.direct": "Jo hawwe noch gjin priveefermeldingen. Wannear’t jo der ien ferstjoere of ûntfange, komt dizze hjir te stean.",
  "empty_column.domain_blocks": "Der binne noch gjin blokkearre domeinen.",
  "empty_column.explore_statuses": "Op dit stuit binne der gjin trends. Kom letter werom!",
  "empty_column.favourited_statuses": "Jo hawwe noch gjin favorite berjochten. Wannear’t jo ien as favoryt markearje, falt dizze hjir te sjen.",
  "empty_column.favourites": "Net ien hat dit berjocht noch as favoryt markearre. Wannear’t ien dit docht, falt dat hjir te sjen.",
  "empty_column.follow_requests": "Jo hawwe noch gjin folchfersiken ûntfongen. Wannear’t jo der ien ûntfange, falt dat hjir te sjen.",
  "empty_column.followed_tags": "Jo folgje noch gjin hashtags. As jo dat wol dogge, wurde se hjir toand.",
  "empty_column.hashtag": "Der is noch neat te finen ûnder dizze hashtag.",
  "empty_column.home": "Dizze tiidline is leech! Folgje mear minsken om it te foljen. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "empty_column.mutes": "Jo hawwe noch gjin brûkers negearre.",
  "empty_column.notification_requests": "Hielendal leech! Der is hjir neat. Wannear’t jo nije meldingen ûntfange, ferskine dizze hjir neffens jo ynstellingen.",
  "empty_column.notifications": "Jo hawwe noch gjin meldingen. Ynteraksjes mei oare minsken sjogge jo hjir.",
  "empty_column.public": "Der is hjir neat! Skriuw eat publyklik, of folgje sels brûkers fan oare servers om it hjir te foljen",
  "error.unexpected_crash.explanation": "Troch in bug in ús koade of in probleem mei de komptabiliteit fan jo browser, koe dizze side net toand wurde.",
  "error.unexpected_crash.explanation_addons": "Dizze side kin net goed toand wurde. Dit probleem komt faaks troch in browserútwreiding of ark foar automatysk oersetten.",
  "error.unexpected_crash.next_steps": "Probearje dizze side te fernijen. Wannear’t dit net helpt is it noch hieltyd mooglik om Mastodon yn in oare browser of mobile app te brûken.",
  "error.unexpected_crash.next_steps_addons": "Probearje dizze út te skeakeljen en de side te fernijen. Wannear’t dit net helpt is it noch hieltyd mooglik om Mastodon yn in oare browser of mobile app te brûken.",
  "errors.unexpected_crash.copy_stacktrace": "Stacktrace nei klamboerd kopiearje",
  "errors.unexpected_crash.report_issue": "Technysk probleem melde",
  "explore.suggested_follows": "Minsken",
  "explore.title": "Populêr",
  "explore.trending_links": "Nijs",
  "explore.trending_statuses": "Berjochten",
  "explore.trending_tags": "Hashtags",
  "featured_carousel.header": "{count, plural, one {Fêstset berjocht} other {Fêstsette berjochten}}",
  "filter_modal.added.context_mismatch_explanation": "Dizze filterkategory is net fan tapassing op de kontekst wêryn jo dit berjocht benadere hawwe. As jo wolle dat it berjocht ek yn dizze kontekst filtere wurdt, moatte jo it filter bewurkje.",
  "filter_modal.added.context_mismatch_title": "Kontekst komt net oerien!",
  "filter_modal.added.expired_explanation": "Dizze filterkategory is ferrûn. Jo moatte de ferrindatum wizigje om de kategory tapasse te kinnen.",
  "filter_modal.added.expired_title": "Filter ferrûn!",
  "filter_modal.added.review_and_configure": "Gean nei {settings_link} om dizze filterkategory opnij te besjen en fierder te konfigurearjen.",
  "filter_modal.added.review_and_configure_title": "Filterynstellingen",
  "filter_modal.added.settings_link": "ynstellingenside",
  "filter_modal.added.short_explanation": "Dit berjocht is tafoege oan de folgjende filterkategory: {title}.",
  "filter_modal.added.title": "Filter tafoege!",
  "filter_modal.select_filter.context_mismatch": "is net fan tapassing op dizze kontekst",
  "filter_modal.select_filter.expired": "ferrûn",
  "filter_modal.select_filter.prompt_new": "Nije kategory: {name}",
  "filter_modal.select_filter.search": "Sykje of tafoegje",
  "filter_modal.select_filter.subtitle": "In besteande kategory brûke of in nije oanmeitsje",
  "filter_modal.select_filter.title": "Dit berjocht filterje",
  "filter_modal.title.status": "In berjocht filterje",
  "filter_warning.matches_filter": "Komt oerien mei filter ‘<span>{title}</span>’",
  "filtered_notifications_banner.pending_requests": "Fan {count, plural, =0 {net ien} one {ien persoan} other {# persoanen}} dy’t jo mooglik kinne",
  "filtered_notifications_banner.title": "Filtere meldingen",
  "firehose.all": "Alles",
  "firehose.local": "Dizze server",
  "firehose.remote": "Oare servers",
  "follow_request.authorize": "Goedkarre",
  "follow_request.reject": "Wegerje",
  "follow_requests.unlocked_explanation": "Ek al is jo account net besletten, de meiwurkers fan {domain} tinke dat jo miskien de folgjende folchfersiken hânmjittich kontrolearje.",
  "follow_suggestions.curated_suggestion": "Spesjaal selektearre",
  "follow_suggestions.dismiss": "Net mear werjaan",
  "follow_suggestions.featured_longer": "Hânmjittich selektearre troch it team fan {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populêr ûnder minsken dy’t jo folgje",
  "follow_suggestions.hints.featured": "Dit profyl is hânmjittich troch it {domain}-team selektearre.",
  "follow_suggestions.hints.friends_of_friends": "Dit profyl is populêr ûnder de minsken dy’t jo folgje.",
  "follow_suggestions.hints.most_followed": "Dit profyl is ien fan de meast folge op {domain}.",
  "follow_suggestions.hints.most_interactions": "Dit profyl hat de lêste tiid in protte oandacht krigen op {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Dit profyl is hast lyk oan de profilen dy’t jo koartlyn folge hawwe.",
  "follow_suggestions.personalized_suggestion": "Personalisearre suggestje",
  "follow_suggestions.popular_suggestion": "Populêre suggestje",
  "follow_suggestions.popular_suggestion_longer": "Populêr op {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Fergelykber mei accounts dy’t jo sûnt koart folgje",
  "follow_suggestions.view_all": "Alles werjaan",
  "follow_suggestions.who_to_follow": "Wa te folgjen",
  "followed_tags": "Folge hashtags",
  "footer.about": "Oer",
  "footer.directory": "Profylmap",
  "footer.get_app": "App downloade",
  "footer.keyboard_shortcuts": "Fluchtoetsen",
  "footer.privacy_policy": "Privacybelied",
  "footer.source_code": "Boarnekoade besjen",
  "footer.status": "Steat",
  "footer.terms_of_service": "Tsjinstbetingsten",
  "generic.saved": "Bewarre",
  "getting_started.heading": "Uteinsette",
  "hashtag.admin_moderation": "Moderaasje-omjouwing fan #{name} iepenje",
  "hashtag.browse": "Berjochten mei #{hashtag} besjen",
  "hashtag.browse_from_account": "Berjochten fan @{name} mei #{hashtag} besjen",
  "hashtag.column_header.tag_mode.all": "en {additional}",
  "hashtag.column_header.tag_mode.any": "of {additional}",
  "hashtag.column_header.tag_mode.none": "sûnder {additional}",
  "hashtag.column_settings.select.no_options_message": "Gjin suggestjes fûn",
  "hashtag.column_settings.select.placeholder": "Folje hashtags yn…",
  "hashtag.column_settings.tag_mode.all": "Allegearre",
  "hashtag.column_settings.tag_mode.any": "Ien fan dizze",
  "hashtag.column_settings.tag_mode.none": "Gjin fan dizze",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} dielnimmer} other {{counter} dielnimmers}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} berjocht} other {{counter} berjochten}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} berjocht} other {{counter} berjochten}} hjoed",
  "hashtag.feature": "Op profyl útljochtsje",
  "hashtag.follow": "Hashtag folgje",
  "hashtag.mute": "#{hashtag} negearje",
  "hashtag.unfeature": "Net op profyl útljochtsje",
  "hashtag.unfollow": "Hashtag ûntfolgje",
  "hashtags.and_other": "…en {count, plural, one {}other {# mear}}",
  "hints.profiles.followers_may_be_missing": "Folgers foar dit profyl kinne ûntbrekke.",
  "hints.profiles.follows_may_be_missing": "De folgers foar dit profyl kinne ûntbrekke.",
  "hints.profiles.posts_may_be_missing": "Der ûntbrekke mooglik berjochten fan dit profyl.",
  "hints.profiles.see_more_followers": "Besjoch mear folgers op {domain}",
  "hints.profiles.see_more_follows": "Besjoch mear folge accounts op {domain}",
  "hints.profiles.see_more_posts": "Besjoch mear berjochten op {domain}",
  "home.column_settings.show_quotes": "Sitaten toane",
  "home.column_settings.show_reblogs": "Boosts toane",
  "home.column_settings.show_replies": "Reaksjes toane",
  "home.hide_announcements": "Meidielingen ferstopje",
  "home.pending_critical_update.body": "Fernij sa gau as mooglik jo Mastodon-server!",
  "home.pending_critical_update.link": "Fernijingen besjen",
  "home.pending_critical_update.title": "Kritike befeiligingsfernijing beskikber!",
  "home.show_announcements": "Meidielingen toane",
  "ignore_notifications_modal.disclaimer": "Mastodon kin brûkers net ynformearje dat jo harren meldingen negearre hawwe. Meldingen negearje sil net foarkomme dat de berjochten sels ferstjoerd wurde.",
  "ignore_notifications_modal.filter_instead": "Yn stee derfan filterje",
  "ignore_notifications_modal.filter_to_act_users": "Jo binne noch hieltyd yn steat om folchfersiken goed- of ôf te karren en om brûkers te rapportearjen",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filterjen foarkomt potinsjele betizing",
  "ignore_notifications_modal.filter_to_review_separately": "Jo kinne filtere meldingen ôfsûnderlik beoardiele",
  "ignore_notifications_modal.ignore": "Meldingen negearje",
  "ignore_notifications_modal.limited_accounts_title": "Meldingen fan beheinde accounts negearje?",
  "ignore_notifications_modal.new_accounts_title": "Meldingen fan nije accounts negearje?",
  "ignore_notifications_modal.not_followers_title": "Meldingen negearje fan minsken dy’t jo net folgje?",
  "ignore_notifications_modal.not_following_title": "Meldingen negearje fan minsken dy’t josels net folgje?",
  "ignore_notifications_modal.private_mentions_title": "Meldingen negearje fan net frege priveeberjochten?",
  "info_button.label": "Help",
  "info_button.what_is_alt_text": "<h1>Wat is alt-tekst?</h1> <p>Alt-tekst biedt ôfbyldingsbeskriuwingen foar minsken mei in fisuele beheining en ferbiningen mei in lege bânbreedte of foar minsken dy’t nei ekstra kontekst sykje.</p><p>Jo kinne de tagonklikheid en de begryplikheid foar elkenien ferbetterje troch dúdlik, koart en objektyf te skriuwen.</p><ul><li>Beskriuw wichtige eleminten</li><li>Fetsje tekst yn ôfbyldingen gear</li><li>Brûk in normale sinsbou</li><li>Mij oertallige ynformaasje</li><li>Fokusje op trends en wichtige befiningen yn komplekse bylden (lykas diagrammen of kaarten)</li></ul>",
  "interaction_modal.go": "Gean",
  "interaction_modal.no_account_yet": "Hawwe jo noch gjin account?",
  "interaction_modal.on_another_server": "Op een oare server",
  "interaction_modal.on_this_server": "Op dizze server",
  "interaction_modal.username_prompt": "Byg. {example}",
  "intervals.full.days": "{number, plural, one {# dei} other {# dagen}} lyn",
  "intervals.full.hours": "{number, plural, one {# oere} other {# oeren}} lyn",
  "intervals.full.minutes": "{number, plural, one {# minút} other {# minuten}} lyn",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "Berjocht booste",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "Omskriuwing",
  "keyboard_shortcuts.down": "Nei ûnder yn list ferpleatse",
  "keyboard_shortcuts.enter": "Berjocht iepenje",
  "keyboard_shortcuts.favourite": "As favoryt markearje",
  "keyboard_shortcuts.favourites": "Favoritenlist iepenje",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Fluchtoetsen",
  "keyboard_shortcuts.home": "Starttiidline toane",
  "keyboard_shortcuts.hotkey": "Fluchtoets",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "Skriuwer fermelde",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "Jo profyl iepenje",
  "keyboard_shortcuts.notifications": "Meldingen toane",
  "keyboard_shortcuts.open_media": "Media iepenje",
  "keyboard_shortcuts.pinned": "Fêstsette berjochten toane",
  "keyboard_shortcuts.profile": "Skriuwersprofyl iepenje",
  "keyboard_shortcuts.reply": "Berjocht beäntwurdzje",
  "keyboard_shortcuts.requests": "Folchfersiken toane",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "CW-fjild ferstopje/toane",
  "keyboard_shortcuts.start": "‘Uteinsette’ iepenje",
  "keyboard_shortcuts.toggle_hidden": "Tekst efter CW-fjild ferstopje/toane",
  "keyboard_shortcuts.toggle_sensitivity": "Media ferstopje/toane",
  "keyboard_shortcuts.toot": "Nij berjocht skriuwe",
  "keyboard_shortcuts.translate": "om in berjocht oer te setten",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "Nei boppe yn list ferpleatse",
  "lightbox.close": "Slute",
  "lightbox.next": "Folgjende",
  "lightbox.previous": "Foarige",
  "lightbox.zoom_in": "Oarspronklike grutte toane",
  "lightbox.zoom_out": "Passend toane",
  "limited_account_hint.action": "Profyl dochs besjen",
  "limited_account_hint.title": "Dit profyl is troch de behearders fan {domain} ferstoppe.",
  "link_preview.author": "Troch {name}",
  "link_preview.more_from_author": "Mear fan {name}",
  "link_preview.shares": "{count, plural, one {{counter} berjocht} other {{counter} berjochten}}",
  "lists.add_member": "Tafoegje",
  "lists.add_to_list": "Oan list tafoegje",
  "lists.add_to_lists": "{name} oan listen tafoegje",
  "lists.create": "Oanmeitsje",
  "lists.create_a_list_to_organize": "Meitsje in nije list oan om jo starttiidline te organisearjen",
  "lists.create_list": "List oanmeitsje",
  "lists.delete": "List fuortsmite",
  "lists.done": "Klear",
  "lists.edit": "List bewurkje",
  "lists.exclusive": "Leden op jo Startside ferstopje",
  "lists.exclusive_hint": "As ien op dizze list stiet, ferstopje dizze persoan dan op jo starttiidline om foar te kommen dat harren berjochten twa kear toand wurde.",
  "lists.find_users_to_add": "Fyn brûkers om ta te foegjen",
  "lists.list_members_count": "{count, plural, one{# lid} other{# leden}}",
  "lists.list_name": "Listnamme",
  "lists.new_list_name": "Nije listnamme",
  "lists.no_lists_yet": "Noch gjin listen.",
  "lists.no_members_yet": "Noch gjin leden.",
  "lists.no_results_found": "Gjin resultaten fûn.",
  "lists.remove_member": "Fuortsmite",
  "lists.replies_policy.followed": "Elke folge brûker",
  "lists.replies_policy.list": "Leden fan de list",
  "lists.replies_policy.none": "Net ien",
  "lists.save": "Bewarje",
  "lists.search": "Sykje",
  "lists.show_replies_to": "Foegje antwurden fan listleden ta oan",
  "load_pending": "{count, plural, one {# nij item} other {# nije items}}",
  "loading_indicator.label": "Lade…",
  "media_gallery.hide": "Ferstopje",
  "moved_to_account_banner.text": "Omdat jo nei {movedToAccount} ferhuze binne is jo account {disabledAccount} op dit stuit útskeakele.",
  "mute_modal.hide_from_notifications": "Meldingen ferstopje",
  "mute_modal.hide_options": "Opsjes ferstopje",
  "mute_modal.indefinite": "Oant ik se net mear negearje",
  "mute_modal.show_options": "Opsjes toane",
  "mute_modal.they_can_mention_and_follow": "De persoan kin jo fermelde en folgje, mar jo sjogge neat mear fan dizze persoan.",
  "mute_modal.they_wont_know": "Se krije net te witten dat se negearre wurde.",
  "mute_modal.title": "Brûker negearje?",
  "mute_modal.you_wont_see_mentions": "Jo sjogge gjin berjochten mear dy’t dizze account fermelde.",
  "mute_modal.you_wont_see_posts": "De persoan kin jo berjochten noch hieltyd sjen, mar jo sjogge harren berjochten net mear.",
  "navigation_bar.about": "Oer",
  "navigation_bar.account_settings": "Wachtwurd en befeiliging",
  "navigation_bar.administration": "Behear",
  "navigation_bar.advanced_interface": "Yn avansearre webomjouwing iepenje",
  "navigation_bar.automated_deletion": "Automatysk berjochten fuortsmite",
  "navigation_bar.blocks": "Blokkearre brûkers",
  "navigation_bar.bookmarks": "Blêdwizers",
  "navigation_bar.direct": "Priveefermeldingen",
  "navigation_bar.domain_blocks": "Blokkearre domeinen",
  "navigation_bar.favourites": "Favoriten",
  "navigation_bar.filters": "Negearre wurden",
  "navigation_bar.follow_requests": "Folchfersiken",
  "navigation_bar.followed_tags": "Folge hashtags",
  "navigation_bar.follows_and_followers": "Folgers en folgjenden",
  "navigation_bar.import_export": "Ymportearje en eksportearje",
  "navigation_bar.lists": "Listen",
  "navigation_bar.live_feed_local": "Livefeed (lokaal)",
  "navigation_bar.live_feed_public": "Livefeed (iepenbier)",
  "navigation_bar.logout": "Ofmelde",
  "navigation_bar.moderation": "Moderaasje",
  "navigation_bar.more": "Mear",
  "navigation_bar.mutes": "Negearre brûkers",
  "navigation_bar.opened_in_classic_interface": "Berjochten, accounts en oare spesifike siden, wurde standert iepene yn de klassike webinterface.",
  "navigation_bar.preferences": "Ynstellingen",
  "navigation_bar.privacy_and_reach": "Privacy en berik",
  "navigation_bar.search": "Sykje",
  "navigation_bar.search_trends": "Sykje / Populêr",
  "navigation_panel.collapse_followed_tags": "Menu foar folge hashtags ynklappe",
  "navigation_panel.collapse_lists": "Listmenu ynklappe",
  "navigation_panel.expand_followed_tags": "Menu foar folge hashtags útklappe",
  "navigation_panel.expand_lists": "Listmenu útklappe",
  "not_signed_in_indicator.not_signed_in": "Jo moatte oanmelde om tagong ta dizze ynformaasje te krijen.",
  "notification.admin.report": "{name} hat {target} rapportearre",
  "notification.admin.report_account": "{name} rapportearre {count, plural, one {in berjocht} other {# berjochten}} fan {target} foar {category}",
  "notification.admin.report_account_other": "{name} rapportearre {count, plural, one {in berjocht} other {# berjochten}} fan {target}",
  "notification.admin.report_statuses": "{name} rapportearre {target} foar {category}",
  "notification.admin.report_statuses_other": "{name} hat {target} rapportearre",
  "notification.admin.sign_up": "{name} hat harren registrearre",
  "notification.admin.sign_up.name_and_others": "{name} en {count, plural, one {# oar} other {# oaren}} hawwe harren registrearre",
  "notification.annual_report.message": "Jo {year} #Wrapstodon stiet klear! Lit de hichtepunten en memorabele mominten fan jo jier sjen op Mastodon!",
  "notification.annual_report.view": "#Wrapstodon besjen",
  "notification.favourite": "{name} hat jo berjocht as favoryt markearre",
  "notification.favourite.name_and_others_with_link": "{name} en <a>{count, plural, one {# oar} other {# oaren}}</a> hawwe jo berjocht as favoryt markearre",
  "notification.favourite_pm": "{name} hat jo priveeberjocht as favoryt markearre",
  "notification.favourite_pm.name_and_others_with_link": "{name} en <a>{count, plural, one {# oar} other {# oaren}}</a> hawwe jo priveeberjocht as favoryt markearre",
  "notification.follow": "{name} folget dy",
  "notification.follow.name_and_others": "{name} en <a>{count, plural, one {# oar persoan} other {# oare persoanen}}</a> folgje jo no",
  "notification.follow_request": "{name} hat dy in folchfersyk stjoerd",
  "notification.follow_request.name_and_others": "{name} en {count, plural, one {# oar} other {# oaren}} hawwe frege om jo te folgjen",
  "notification.label.mention": "Fermelding",
  "notification.label.private_mention": "Priveeberjocht",
  "notification.label.private_reply": "Priveereaksje",
  "notification.label.reply": "Beäntwurdzje",
  "notification.mention": "Fermelding",
  "notification.mentioned_you": "{name} hat dy fermeld",
  "notification.moderation-warning.learn_more": "Mear ynfo",
  "notification.moderation_warning": "Jo hawwe in moderaasje-warskôging ûntfongen",
  "notification.moderation_warning.action_delete_statuses": "Guon fan jo berjochten binne fuortsmiten.",
  "notification.moderation_warning.action_disable": "Jo account is útskeakele.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Guon fan jo berjochten binne as gefoelich markearre.",
  "notification.moderation_warning.action_none": "Jo account hat in moderaasje-warskôging ûntfongen.",
  "notification.moderation_warning.action_sensitive": "Jo berjochten wurde fan no ôf as gefoelich markearre.",
  "notification.moderation_warning.action_silence": "Jo account is beheind.",
  "notification.moderation_warning.action_suspend": "Jo account is útsteld.",
  "notification.own_poll": "Jo poll is beëinige",
  "notification.poll": "In enkête dêr’t jo oan meidien hawwe is beëinige",
  "notification.reblog": "{name} hat jo berjocht boost",
  "notification.reblog.name_and_others_with_link": "{name} en <a>{count, plural, one {# oar} other {# oaren}}</a> hawwe jo berjocht boost",
  "notification.relationships_severance_event": "Ferlerne ferbiningen mei {name}",
  "notification.relationships_severance_event.account_suspension": "In behearder fan {from} hat {target} útsteld, wat betsjut dat jo gjin updates mear fan harren ûntfange kinne of mei harren kommunisearje kinne.",
  "notification.relationships_severance_event.domain_block": "In behearder fan {from} hat {target} blokkearre, ynklusyf {followersCount} fan jo folgers en {followingCount, plural, one {# account} other {# accounts}} dy’t jo folgje.",
  "notification.relationships_severance_event.learn_more": "Mear ynfo",
  "notification.relationships_severance_event.user_domain_block": "Jo hawwe {target} blokkearre, wêrmei’t jo {followersCount} fan jo folgers en {followingCount, plural, one {# account} other {# accounts}} dy’t jo folgje ferlern binne.",
  "notification.status": "{name} hat in berjocht pleatst",
  "notification.update": "{name} hat in berjocht bewurke",
  "notification_requests.accept": "Akseptearje",
  "notification_requests.accept_multiple": "{count, plural, one {# fersyk akseptearje…} other {# fersiken akseptearje…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Fersyk akseptearje} other {Fersiken akseptearje}}",
  "notification_requests.confirm_accept_multiple.message": "Jo steane op it punt om {count, plural, one {ien meldingsfersyk} other {# meldingsfersiken}} te akseptearjen. Binne jo wis dat jo trochgean wolle?",
  "notification_requests.confirm_accept_multiple.title": "Meldingsfersiken akseptearje?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Fersyk ôfwize} other {Fersiken ôfwize}}",
  "notification_requests.confirm_dismiss_multiple.message": "Jo steane op it punt om {count, plural, one {ien meldingsfersyk} other {# meldingsfersiken}} ôf te wizen. Jo sille net yn steat wêze om {count, plural, one {hier} other {hier}} wer maklik tagong ta te krijen. Wolle jo trochgean?",
  "notification_requests.confirm_dismiss_multiple.title": "Meldingsfersiken ôfwize?",
  "notification_requests.dismiss": "Ofwize",
  "notification_requests.dismiss_multiple": "{count, plural, one {# fersyk ôfwize…} other {# fersiken ôfwize…}}",
  "notification_requests.edit_selection": "Bewurkje",
  "notification_requests.exit_selection": "Klear",
  "notification_requests.explainer_for_limited_account": "Meldingen fan dizze account binne filtere, omdat dizze account troch in moderator beheind is.",
  "notification_requests.explainer_for_limited_remote_account": "Meldingen fan dizze account binne filtere, omdat dizze account of harren server troch in moderator beheind is.",
  "notification_requests.maximize": "Maksimalisearje",
  "notification_requests.minimize_banner": "Banner mei filtere meldingen minimalisearje",
  "notification_requests.notifications_from": "Meldingen fan {name}",
  "notification_requests.title": "Filtere meldingen",
  "notification_requests.view": "Meldingen besjen",
  "notifications.clear": "Meldingen wiskje",
  "notifications.clear_confirmation": "Binne jo wis dat jo al jo meldingen permanint fuortsmite wolle?",
  "notifications.clear_title": "Meldingen fuortsmite?",
  "notifications.column_settings.admin.report": "Nije rapportaazjes:",
  "notifications.column_settings.admin.sign_up": "Nije registraasjes:",
  "notifications.column_settings.alert": "Desktopmeldingen",
  "notifications.column_settings.favourite": "Favoriten:",
  "notifications.column_settings.filter_bar.advanced": "Alle kategoryen toane",
  "notifications.column_settings.filter_bar.category": "Flugge filterbalke",
  "notifications.column_settings.follow": "Nije folgers:",
  "notifications.column_settings.follow_request": "Nij folchfersyk:",
  "notifications.column_settings.group": "Groepearje",
  "notifications.column_settings.mention": "Fermeldingen:",
  "notifications.column_settings.poll": "Enkêteresultaten:",
  "notifications.column_settings.push": "Pushmeldingen",
  "notifications.column_settings.reblog": "Boosts:",
  "notifications.column_settings.show": "Yn kolom toane",
  "notifications.column_settings.sound": "Lûd ôfspylje",
  "notifications.column_settings.status": "Nije berjochten:",
  "notifications.column_settings.unread_notifications.category": "Net lêzen meldingen",
  "notifications.column_settings.unread_notifications.highlight": "Net lêzen meldingen markearje",
  "notifications.column_settings.update": "Bewurkingen:",
  "notifications.filter.all": "Alle",
  "notifications.filter.boosts": "Boosts",
  "notifications.filter.favourites": "Favoriten",
  "notifications.filter.follows": "Folget",
  "notifications.filter.mentions": "Fermeldingen",
  "notifications.filter.polls": "Pollresultaten",
  "notifications.filter.statuses": "Fernijingen fan minsken dy’t jo folgje",
  "notifications.grant_permission": "Tastimming jaan.",
  "notifications.group": "{count} meldingen",
  "notifications.mark_as_read": "Alle meldingen as lêzen markearje",
  "notifications.permission_denied": "Desktopmeldingen binne net beskikber, omdat in eardere browsertastimming wegere waard",
  "notifications.permission_denied_alert": "Desktopmeldingen kinne net ynskeakele wurde, omdat in eardere browsertastimming wegere waard",
  "notifications.permission_required": "Desktopmeldingen binne net beskikber, omdat de nedige tastimming net ferliend is.",
  "notifications.policy.accept": "Akseptearje",
  "notifications.policy.accept_hint": "Yn meldingen toane",
  "notifications.policy.drop": "Negearje",
  "notifications.policy.drop_hint": "Permanint fuortsmite",
  "notifications.policy.filter": "Filter",
  "notifications.policy.filter_hint": "Nei filtere ynboks foar meldingen ferstjoere",
  "notifications.policy.filter_limited_accounts_hint": "Beheind troch servermoderatoren",
  "notifications.policy.filter_limited_accounts_title": "Moderearre accounts",
  "notifications.policy.filter_new_accounts.hint": "Yn de ôfrûne {days, plural, one {dei} other {# dagen}} registrearre",
  "notifications.policy.filter_new_accounts_title": "Nije accounts",
  "notifications.policy.filter_not_followers_hint": "Ynklusyf minsken dy’t jo koarter as {days, plural, one {dei} other {# dagen}} folgje",
  "notifications.policy.filter_not_followers_title": "Minsken dy’t jo net folgje",
  "notifications.policy.filter_not_following_hint": "Oant jo se hânmjittich goedkarre",
  "notifications.policy.filter_not_following_title": "Minsken dy’t josels net folgje",
  "notifications.policy.filter_private_mentions_hint": "Unsichtber útsein it in antwurd is op in priveeberjocht fan jo of wannear’t jo de ôfstjoerder folgje",
  "notifications.policy.filter_private_mentions_title": "Net frege priveeberjochten",
  "notifications.policy.title": "Meldingen beheare fan…",
  "notifications_permission_banner.enable": "Desktopmeldingen ynskeakelje",
  "notifications_permission_banner.how_to_control": "Om meldingen te ûntfangen wannear’t Mastodon net iepen stiet. Jo kinne krekt bepale hokker soarte fan ynteraksjes wol of gjin desktopmeldingen jouwe fia de boppesteande {icon} knop.",
  "notifications_permission_banner.title": "Mis neat",
  "onboarding.follows.back": "Tebek",
  "onboarding.follows.empty": "Spitigernôch kinne op dit stuit gjin resultaten toand wurde. Jo kinne probearje te sykjen of te blêdzjen troch de ferkenningsside om minsken te finen dy’t jo folgje kinne, of probearje it letter opnij.",
  "onboarding.follows.search": "Sykje",
  "onboarding.follows.title": "Folgje minsken om te begjinnen",
  "onboarding.profile.discoverable": "Meitsje myn profyl te finen",
  "onboarding.profile.discoverable_hint": "Wannear’t jo akkoard gean mei it te finen wêzen op Mastodon, ferskine jo berjochten yn sykresultaten en kinne se trending wurde, en jo profyl kin oan oare minsken oanrekommandearre wurde wannear’t se fergelykbere ynteressen hawwe.",
  "onboarding.profile.display_name": "Werjeftenamme",
  "onboarding.profile.display_name_hint": "Jo folsleine namme of in aardige bynamme…",
  "onboarding.profile.note": "Biografy",
  "onboarding.profile.note_hint": "Jo kinne oare minsken @fermelde of #hashtags brûke…",
  "onboarding.profile.title": "Profyl ynstelle",
  "onboarding.profile.upload_avatar": "Profylfoto oplade",
  "onboarding.profile.upload_header": "Omslachfoto foar profyl oplade",
  "password_confirmation.exceeds_maxlength": "Wachtwurdbefêstiging giet oer de maksimale wachtwurdlingte",
  "password_confirmation.mismatching": "Wachtwurdbefêstiging komt net oerien",
  "picture_in_picture.restore": "Tebeksette",
  "poll.closed": "Sluten",
  "poll.refresh": "Ferfarskje",
  "poll.reveal": "Resultaten besjen",
  "poll.total_people": "{count, plural, one {# persoan} other {# persoanen}}",
  "poll.total_votes": "{count, plural, one {# stim} other {# stimmen}}",
  "poll.vote": "Stimme",
  "poll.voted": "Jo hawwe hjir op stimd",
  "poll.votes": "{votes, plural, one {# stim} other {# stimmen}}",
  "poll_button.add_poll": "Poll tafoegje",
  "poll_button.remove_poll": "Enkête fuortsmite",
  "privacy.change": "Sichtberheid fan berjocht oanpasse",
  "privacy.direct.long": "Elkenien dy’ yn it berjocht fermeld wurdt",
  "privacy.direct.short": "Priveefermelding",
  "privacy.private.long": "Allinnich jo folgers",
  "privacy.private.short": "Folgers",
  "privacy.public.long": "Elkenien op Mastodon en dêrbûten",
  "privacy.public.short": "Iepenbier",
  "privacy.unlisted.additional": "Dit is fergelykber mei iepenbier, útsein dat it berjocht net ferskynt op iepenbiere tiidlijnen of hashtags, ûnder ferkenne of Mastodon sykje, sels as jo jo account dêrfoar ynsteld hawwe.",
  "privacy.unlisted.short": "Minder iepenbier",
  "privacy_policy.last_updated": "Lêst bywurke op {date}",
  "privacy_policy.title": "Privacybelied",
  "recommended": "Oanrekommandearre",
  "refresh": "Ferfarskje",
  "regeneration_indicator.please_stand_by": "In amerijke.",
  "regeneration_indicator.preparing_your_home_feed": "Tarieden fan jo starttiidline…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dei} other {# dagen}} lyn",
  "relative_time.full.hours": "{number, plural, one {# oere} other {# oeren}} lyn",
  "relative_time.full.just_now": "sakrekt",
  "relative_time.full.minutes": "{number, plural, one {# minút} other {# minuten}} lyn",
  "relative_time.full.seconds": "{number, plural, one {# sekonde} other {# sekonden}} lyn",
  "relative_time.hours": "{number}o",
  "relative_time.just_now": "no",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hjoed",
  "reply_indicator.attachments": "{count, plural, one {# bylage} other {# bylagen}}",
  "reply_indicator.cancel": "Annulearje",
  "reply_indicator.poll": "Peiling",
  "report.block": "Blokkearje",
  "report.block_explanation": "Jo sille harren berjochten net sjen kinne. Se sille jo berjochten net sjen kinne en jo net folgje kinne. Se sille wol sjen kinne dat se blokkearre binne.",
  "report.categories.legal": "Juridysk",
  "report.categories.other": "Oars",
  "report.categories.spam": "Spam",
  "report.categories.violation": "De ynhâld oertrêdet ien of mear serverrigels",
  "report.category.subtitle": "Selektearje wat it bêste past",
  "report.category.title": "Fertel ús wat der mei dit {type} oan de hân is",
  "report.category.title_account": "profyl",
  "report.category.title_status": "berjocht",
  "report.close": "Klear",
  "report.comment.title": "Tinksto dat wy noch mear witte moatte?",
  "report.forward": "Nei {target} trochstjoere",
  "report.forward_hint": "De account stiet op in oare server. Wolle jo dêr ek in anonimisearre kopy fan dizze rapportaazje nei ta stjoere?",
  "report.mute": "Negearje",
  "report.mute_explanation": "Jo kinne harren berjochten net sjen. Jo kinne noch wol folge wurde en jo berjochten binne noch sichtber, mar dyjinge kin net sjen dat dy negearre wurdt.",
  "report.next": "Folgjende",
  "report.placeholder": "Type or paste additional comments",
  "report.reasons.dislike": "Ik fyn der neat oan",
  "report.reasons.dislike_description": "It is net eat watsto sjen wolst",
  "report.reasons.legal": "It is wetlik net tastien",
  "report.reasons.legal_description": "Jo binne fan miening dat it de wet fan jo lân of dat fan de serverlokaasje skeint",
  "report.reasons.other": "It is wat oars",
  "report.reasons.other_description": "It probleem stiet der net tusken",
  "report.reasons.spam": "It is spam",
  "report.reasons.spam_description": "Skeadlike keppelingen, reklame, mislieding of werheljende antwurden",
  "report.reasons.violation": "It skeint de serverregels",
  "report.reasons.violation_description": "Jo witte dat it spesifike regels skeint",
  "report.rules.subtitle": "Selektearje wat fan tapassing is",
  "report.rules.title": "Hokker regels wurde skeind?",
  "report.statuses.subtitle": "Selektearje wat fan tapassing is",
  "report.statuses.title": "Binne der berjochten dy’t dizze rapportaazje stypje?",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report.thanks.take_action": "Hjir binne jo opsjes wêrmei’t jo bepale kinne wat jo yn Mastodon sjen wolle:",
  "report.thanks.take_action_actionable": "Wylst wy jo rapportaazje beoardiele, kinne jo dizze maatregels tsjin @{name} nimme:",
  "report.thanks.title": "Wolle jo dit net sjen?",
  "report.thanks.title_actionable": "Tank foar it rapportearjen. Wy sille der nei sjen.",
  "report.unfollow": "{name} ûntfolgje",
  "report.unfollow_explanation": "Jo folgje dizze account. Om harren berjochten net mear op jo starttiidline te sjen, kinne jo dyjinge ûntfolgje.",
  "report_notification.attached_statuses": "{count, plural, one {{count} berjocht} other {{count} berjochten}} tafoege",
  "report_notification.categories.legal": "Juridysk",
  "report_notification.categories.legal_sentence": "yllegale ynhâld",
  "report_notification.categories.other": "Oars",
  "report_notification.categories.other_sentence": "oars",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Skeinde regels",
  "report_notification.categories.violation_sentence": "skeinde regels",
  "report_notification.open": "Rapport iepenje",
  "search.clear": "Sykopdracht wiskje",
  "search.no_recent_searches": "Gjin resinte sykopdrachten",
  "search.placeholder": "Sykje",
  "search.quick_action.account_search": "Accounts dy’t oerienkomme mei {x}",
  "search.quick_action.go_to_account": "Gean nei account {x}",
  "search.quick_action.go_to_hashtag": "Gean nei hashtag {x}",
  "search.quick_action.open_url": "URL yn Mastodon iepenje",
  "search.quick_action.status_search": "Berjochten dy’t oerienkomme mei {x}",
  "search.search_or_paste": "Sykje of fier URL yn",
  "search_popout.full_text_search_disabled_message": "Net beskikber op {domain}.",
  "search_popout.full_text_search_logged_out_message": "Allinnich beskikber as jo oanmeld binne.",
  "search_popout.language_code": "ISO-taalkoade",
  "search_popout.options": "Sykopsjes",
  "search_popout.quick_actions": "Flugge aksjes",
  "search_popout.recent": "Resinte sykopdrachten",
  "search_popout.specific_date": "spesifike datum",
  "search_popout.user": "brûker",
  "search_results.accounts": "Profilen",
  "search_results.all": "Alles",
  "search_results.hashtags": "Hashtags",
  "search_results.no_results": "Gjin resultaten.",
  "search_results.no_search_yet": "Probearje te sykjen nei berjochten, profilen of hashtags.",
  "search_results.see_all": "Alles besjen",
  "search_results.statuses": "Berjochten",
  "search_results.title": "Sykje nei ‘{q}’",
  "server_banner.about_active_users": "Oantal brûkers yn de ôfrûne 30 dagen (MAU)",
  "server_banner.active_users": "warbere brûkers",
  "server_banner.administered_by": "Beheard troch:",
  "server_banner.is_one_of_many": "{domain} is ien fan de protte ôfhinklike Mastodon-servers dy’t jo brûke kinne om diel te nimmen oan de fediverse.",
  "server_banner.server_stats": "Serverstatistiken:",
  "sign_in_banner.create_account": "Account registrearje",
  "sign_in_banner.follow_anyone": "Folgje elkenien yn de fediverse en sjoch it allegearre yn gronologyske folchoarder. Gjin algoritmen, advertinsjes of clickbaits.",
  "sign_in_banner.mastodon_is": "Mastodon is de beste manier om wat der bart by te hâlden.",
  "sign_in_banner.sign_in": "Oanmelde",
  "sign_in_banner.sso_redirect": "Oanmelde of Registrearje",
  "status.admin_account": "Moderaasje-omjouwing fan @{name} iepenje",
  "status.admin_domain": "Moderaasje-omjouwing fan {domain} iepenje",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "@{name} blokkearje",
  "status.bookmark": "Blêdwizer tafoegje",
  "status.cancel_reblog_private": "Net langer booste",
  "status.cannot_reblog": "Dit berjocht kin net boost wurde",
  "status.continued_thread": "Ferfolgje it petear",
  "status.copy": "Copy link to status",
  "status.delete": "Fuortsmite",
  "status.detailed_status": "Detaillearre petearoersjoch",
  "status.direct": "Privee fermelde @{name}",
  "status.direct_indicator": "Priveefermelding",
  "status.edit": "Bewurkje",
  "status.edited": "Lêst bywurke op {date}",
  "status.edited_x_times": "{count, plural, one {{count} kear} other {{count} kearen}} bewurke",
  "status.embed": "Koade om op te nimmen",
  "status.favourite": "Favoryt",
  "status.filter": "Dit berjocht filterje",
  "status.history.created": "{name} makke dit {date}",
  "status.history.edited": "{name} bewurke dit {date}",
  "status.load_more": "Mear lade",
  "status.media.open": "Klik om te iepenjen",
  "status.media.show": "Klik om te toanen",
  "status.media_hidden": "Media ferstoppe",
  "status.mention": "@{name} fermelde",
  "status.more": "Mear",
  "status.mute": "@{name} negearje",
  "status.mute_conversation": "Petear negearje",
  "status.open": "Dit berjocht útklappe",
  "status.pin": "Op profylside fêstsette",
  "status.quote_error.filtered": "Ferburgen troch ien fan jo filters",
  "status.read_more": "Mear ynfo",
  "status.reblog": "Booste",
  "status.reblogged_by": "{name} hat boost",
  "status.reblogs.empty": "Net ien hat dit berjocht noch boost. Wannear’t ien dit docht, falt dat hjir te sjen.",
  "status.redraft": "Fuortsmite en opnij opstelle",
  "status.remove_bookmark": "Blêdwizer fuortsmite",
  "status.remove_favourite": "Ut favoriten fuortsmite",
  "status.replied_in_thread": "Antwurde yn petear",
  "status.replied_to": "Antwurde op {name}",
  "status.reply": "Beäntwurdzje",
  "status.replyAll": "Alle beäntwurdzje",
  "status.report": "@{name} rapportearje",
  "status.sensitive_warning": "Gefoelige ynhâld",
  "status.share": "Diele",
  "status.show_less_all": "Alles minder toane",
  "status.show_more_all": "Alles mear toane",
  "status.show_original": "Orizjineel besjen",
  "status.title.with_attachments": "{user} hat {attachmentCount, plural, one {ien bylage} other {{attachmentCount} bylagen}} tafoege",
  "status.translate": "Oersette",
  "status.translated_from_with": "Fan {lang} út oersetten mei {provider}",
  "status.uncached_media_warning": "Foarfertoaning net beskikber",
  "status.unmute_conversation": "Petear net mear negearje",
  "status.unpin": "Fan profylside losmeitsje",
  "subscribed_languages.lead": "Nei de wiziging wurde allinnich berjochten fan selektearre talen op jo starttiidline en yn listen werjaan.",
  "subscribed_languages.save": "Wizigingen bewarje",
  "subscribed_languages.target": "Toande talen foar {target} wizigje",
  "tabs_bar.home": "Startside",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Meldingen",
  "tabs_bar.publish": "Nij berjocht",
  "tabs_bar.search": "Sykje",
  "terms_of_service.effective_as_of": "Effektyf fan {date} ôf",
  "terms_of_service.title": "Gebrûksbetingsten",
  "terms_of_service.upcoming_changes_on": "Oankommende wizigingen op {date}",
  "time_remaining.days": "{number, plural, one {# dei} other {# dagen}} te gean",
  "time_remaining.hours": "{number, plural, one {# oere} other {# oeren}} te gean",
  "time_remaining.minutes": "{number, plural, one {# minút} other {# minuten}} te gean",
  "time_remaining.moments": "Noch krekt efkes te gean",
  "time_remaining.seconds": "{number, plural, one {# sekonde} other {# sekonden}} te gean",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persoan} other {{counter} persoanen}} {days, plural, one {de ôfrûne dei} other {de ôfrûne {days} dagen}}",
  "trends.trending_now": "Aktuele trends",
  "ui.beforeunload": "Jo konsept giet ferlern wannear’t jo Mastodon ferlitte.",
  "units.short.billion": "{count} mrd.",
  "units.short.million": "{count} mln.",
  "units.short.thousand": "{count}k",
  "upload_area.title": "Hjir nei ta slepe om op te laden",
  "upload_button.label": "Ofbyldingen, in fideo- of in lûdsbestân tafoegje",
  "upload_error.limit": "Oer de oplaadlimyt fan bestân.",
  "upload_error.poll": "It opladen fan bestannen is yn enkêten net tastien.",
  "upload_form.drag_and_drop.instructions": "Druk op spaasje of Enter om in mediabylage op te pakken. Bruk de pylktoetsen om de bylage yn in bepaalde rjochting te ferpleatsen. Druk opnij op de spaasjebalke of Enter om de mediabylage op de nije posysje te pleatsen, of druk op Esc om te annulearjen.",
  "upload_form.drag_and_drop.on_drag_cancel": "Slepen is annulearre. Mediabylage {item} is net ferpleatst.",
  "upload_form.drag_and_drop.on_drag_end": "Mediabylage {item} is net ferpleatst.",
  "upload_form.drag_and_drop.on_drag_over": "Mediabylage {item} is ferpleatst.",
  "upload_form.drag_and_drop.on_drag_start": "Mediabylage {item} is oppakt.",
  "upload_form.edit": "Bewurkje",
  "upload_progress.label": "Uploading…",
  "upload_progress.processing": "Dwaande…",
  "username.taken": "Dy brûkersnamme is al yn gebrûk. Probearje in oare",
  "video.close": "Fideo slute",
  "video.download": "Bestân downloade",
  "video.exit_fullscreen": "Folslein skerm slute",
  "video.expand": "Fideo grutter meitsje",
  "video.fullscreen": "Folslein skerm",
  "video.hide": "Fideo ferstopje",
  "video.mute": "Negearje",
  "video.pause": "Skoft",
  "video.play": "Ofspylje",
  "video.skip_backward": "Tebek",
  "video.skip_forward": "Foarút",
  "video.unmute": "Net mear negearje",
  "video.volume_down": "Folume omleech",
  "video.volume_up": "Folume omheech"
}
